const state = {
  errDisplayed: false,
  loading: false,
}

const mutations = {
  SET_ERR_DISPLAYED: (state, errDisplayed) => {
    state.errDisplayed = errDisplayed
  },
  SET_LOADING: (state, loading) => {
    state.loading = loading
  },
}
const actions = {
  displayError({ commit }, parameter) {
    return new Promise((resolve, reject) => {
      console.log('displayError parameter', parameter)
      if (!state.errDisplayed) {
        if (parameter.message) {
          alert(parameter.message)
        } else {
          alert('System Failure. Please contact system admin.')
        }
        resolve(state.errDisplayed)
        commit('SET_ERR_DISPLAYED', true)

        // only display once in ten second
        setTimeout(() => {
          commit('SET_ERR_DISPLAYED', false)
        }, 3000)
      }
    })
  },
  loading({ commit }, parameter) {
    return new Promise((resolve, reject) => {
      commit('SET_LOADING', parameter)
      resolve(parameter)
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
